export { default as GDMTableCell } from './GDMTableCell';

export type { GDMTableCellComponent, GDMTableCellProps } from './GDMTableCell.type';
